// Heading copy for the Company Stock advice step. Like the Goals/SSI steps the
// heading is returned as `{ text, bold }` segments so a fragment ("all" or the
// "XX%") can be rendered bold and darker within an otherwise-regular sentence.

const t = text => ({ text })
const b = text => ({ text, bold: true })

/**
 * Returns the heading segments for the Company Stock step.
 *
 * @param {boolean} isModified      whether the user has a modified case
 * @param {boolean} hasUnrestricted whether the user has any unrestricted stock
 * @param {number}  sellPercent     aggregate % of unrestricted stock being sold
 * @returns {Array<{ text: string, bold?: boolean }>}
 */
export function getHeadingSegments({ isModified, hasUnrestricted, sellPercent }) {
  // Only restricted stock: nothing can be sold, so we make no recommendation.
  if (!hasUnrestricted) {
    return [t("You're unable to sell any of your restricted company stock.")]
  }

  // Recommended case: we always recommend selling 100%.
  if (!isModified) {
    return [t('We recommend selling '), b('all'), t(' of your unrestricted company stock.')]
  }

  // Modified case: reflect what the user chose in the "make changes" drawer.
  if (sellPercent > 0) {
    return [
      t("You've chosen to sell "),
      b(`${sellPercent}%`),
      t(' of your unrestricted company stock.'),
    ]
  }

  return [t("You've chosen not to sell any of your unrestricted company stock.")]
}
